<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Член диссертационного совета:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat  v-if="!isOnlyRead">
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">
                  {{findNameObj('person',props.item.person)}}
                </td>

                <td class="justify-center">{{props.item.email}}</td>
                <td class="justify-center">{{props.item. researcherID}}</td>
                <td class="justify-center">{{props.item.scopusAutorID}}</td>
                <td class="justify-center">{{props.item.spin}}</td>
                <td class="justify-center"><v-icon v-if="props.item.chairman">done</v-icon> <v-icon v-else>close</v-icon></td>
                <td class="justify-center"><v-icon v-if="props.item. viceChairman">done</v-icon> <v-icon v-else>close</v-icon></td>
                <td class="justify-center"><v-icon v-if="props.item.scientificSecretary">done</v-icon> <v-icon v-else>close</v-icon></td>
                <td class="justify-center">{{findNameObj('scientificField',props.item.scientificField)}}</td>
                <td class="justify-center " v-bind="selected" v-if="!isOnlyRead">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Dissertation_council_member @addItem="addItem"
                    @ended="closedForm"
                    @refreshItem="refreshItem"
                    v-bind="selected"
                    v-bind:info="$route.params.id"
                    v-if="opened_form"
      >
      </Dissertation_council_member>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import Dissertation_council_member  from "../forms/Dissertation_council_member"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest,isOnlyReadPermission} from "../../../../../helper";

    export default {
        name: "ListDissertation_council_member",
        components: {Dissertation_council_member},
        mixins: [UserDataMixin],
        props: {
            isDetail: Boolean,
        },
        data () {
            return {
                URL_LIST: urls.getUrl('admin|diss|models|dissertation_council_member-list', 'list'),
                URL_DELETE: urls.getUrl('admin|diss|models|dissertation_council_member-detail', 'destroy'),

                selectors:{
                    scientificField:[],
                    person:[]
                },

                total: 0,
                items: [],
                loading: true,
                pagination: {},
                headers: [
                    {text: 'ФИО', sortable: false, align: 'justify-center',},
                    {text: 'email', sortable: false, align: 'justify-center', },
                    {text: 'Researcher ID (Web of science)', sortable: false, align: 'justify-center', },
                    {text: 'Autor ID (Scopus)', sortable: false, align: 'justify-center', },
                    {text: 'SPIN (РИНЦ)', sortable: false, align: 'justify-center', },
                    {text: 'Ученый секретарь', sortable: false, align: 'justify-center', },
                    {text: 'Председатель', sortable: false, align: 'justify-center', },
                    {text: 'Заместитель председателя', sortable: false, align: 'justify-center', },
                    {text: 'Научная специальность', sortable: false, align: 'justify-center',},
                    {text: 'Действия', sortable: false, align: 'justify-center',}
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },


        created() {
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_field/"
            this.loadSelector('scientificField',url)

            url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/person/"
            this.load(this, url)

            if (!this.isDetail)
              this.$store.commit('mainpage/changeTitle', 'Члены диссертационных советов');
        },
        methods: {
          isOnlyRead(){
            return isOnlyReadPermission
          },
            load: function (app, url) {
                if (url === null) {
                    app.loadingPage = true;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors.person.push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url);
                    });
            },
            findNameObj(edit,id){
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                }else{
                    return ""
                }
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            getItems () {
                this.loading = true
                let url =  this.URL_LIST
                if (this.pagination.page!==undefined){
                    url =  this.URL_LIST+"?page="+this.pagination.page +"&page_size="+ this.pagination.rowsPerPage
                    if (this.isDetail)
                        url = url +"&dissertationCouncil=" + this.$route.params.id
                }

                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
